import { AuditSocialMediaFiltersController } from './audit-social-media-filters.controller'

function auditSocialMediaFilters () {
  return {
    restrict: 'E',
    scope: {
      filters: '=',
      filtersList: '<'
    },
    templateUrl: '/audit/directives/audit-social-media-filters/audit-social-media-filters.html?$$REVISION$$',
    controller: AuditSocialMediaFiltersController
  }
}

export { auditSocialMediaFilters }
